module.exports = __webpack_public_path__ + "img/FR30002.95db4adc.png";